
import React, { PureComponent } from 'react';
import Constants from '../Constants.js';
import Styles from './BoardStyles.js'

class InnerTile extends PureComponent {
  render() {
    return (
      <div
        style={{
          ...Styles.Tile,
          ...Styles.InnerTile,
          backgroundColor: (this.props.transitioning ? this.props.colors.secondary : Constants.innerColor),
          borderTopLeftRadius: (this.props.topLeftRounded ? Constants.innerBorderRadius : 0 ) + 'px',
          borderTopRightRadius: (this.props.topRightRounded ? Constants.innerBorderRadius : 0 ) + 'px',
          borderBottomRightRadius: (this.props.bottomRightRounded ? Constants.innerBorderRadius : 0 ) + 'px',
          borderBottomLeftRadius: (this.props.bottomLeftRounded ? Constants.innerBorderRadius : 0 ) + 'px',
          left: (this.props.col * Constants.tileSize) + 'px',
          top: (this.props.row * Constants.tileSize) + 'px',
        }}
      />
    );
  }
}

export default InnerTile;
